// src/store/index.js
import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import user from './modules/user'
import config from './modules/config'
import notification from './modules/notification'

export default createStore({
    plugins: [
        createPersistedState({
            key: 'vuex',
            paths: [
                'user',
                'config'
            ],
            storage: window.localStorage,
        })
    ],
    modules: {
        user,
        config,
        notification
    }
})
